import React from 'react';
import { twMerge } from 'tailwind-merge';

import { SafeHTML } from '@/components/SafeHTML';

import type { FaqItem as FaqItemType } from '../types';

interface FaqItemProps {
  item: FaqItemType;
  index: number;
  isOpen: boolean;
  onToggle: (index: number) => void;
  questionClassName?: string;
}

/**
 * Individual FAQ item with collapsible answer
 */
export const FaqItem: React.FC<FaqItemProps> = ({
  item,
  index,
  isOpen,
  onToggle,
  questionClassName = '',
}) => (
  <div className="rounded-lg border border-gray-200">
    <button
      type="button"
      onClick={() => onToggle(index)}
      className="flex w-full items-center justify-between px-4 py-2 text-left transition-colors hover:bg-gray-50"
    >
      <span
        className={twMerge('pr-4 font-neutrif text-base', questionClassName)}
      >
        {item.question}
      </span>
      <span className="shrink-0 text-2xl">{isOpen ? '−' : '+'}</span>
    </button>
    <div
      className={`overflow-hidden transition-all duration-300 ${
        isOpen ? 'max-h-[2000px]' : 'max-h-0'
      }`}
    >
      <div className="prose max-w-none px-6 pb-4">
        <SafeHTML html={item.reponse} />
      </div>
    </div>
  </div>
);
